export default class BoundInstanceRequest {
  instances: string[];

  constructor(obj: any) {
    this.instances = obj.instances || [];
  }

  get isInstancesEmpty(): boolean {
    return this.instances.length === 0;
  }

  addNewInstance(instanceId: string) {
    this.instances.push(instanceId);
  }
}
